import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class InventarioFisicoDetalleService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    agregarProductoInventarioFisico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisico_detalleInputType, $detalle: [inventario_fisico_detalleInputType], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          inventario_fisico_detalle {
            agregarProductoInventarioFisico(entidad: $entidad, detalle: $detalle, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  saldo_actual
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico_detalle.agregarProductoInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    obtenerProductoInventarioFisico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisico_detalleInputType, $detalle: [inventario_fisico_detalleInputType], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          inventario_fisico_detalle {
            obtenerProductoInventarioFisico(entidad: $entidad, detalle: $detalle, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  producto_nombre
                  sku
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  saldo_actual
                }
              }
            }
          }
        }        
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico_detalle.obtenerProductoInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    agregarProductoTomaInventario(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisico_detalleInputType, $detalle: [inventario_fisico_detalleInputType]) {
          inventario_fisico_detalle {
            agregarProductoTomaInventario(entidad: $entidad, detalle: $detalle) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  cantidad_contada
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico_detalle.agregarProductoTomaInventario;
            callback({ mensajes, respuesta });
        });
    }
}
InventarioFisicoDetalleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InventarioFisicoDetalleService_Factory() { return new InventarioFisicoDetalleService(i0.ɵɵinject(i1.GraphQLClient)); }, token: InventarioFisicoDetalleService, providedIn: "root" });
